export default "__VITE_ASSET__0jVYNCkU__"